import type { PropsWithChildren, FunctionComponent } from 'react'
import { cloneElement, useMemo } from 'react'
import { useRouteMatch } from 'react-router'
import { AuthenticationDomainRedirect } from '@retailer-platform/domain-authentication'
import { DashSwitch } from '../../../legacy/dash-components/dash-switch/DashSwitch'
import { DashRoute } from '../../../legacy/dash-components/dash-route/DashRoute'
import { DashRedirect } from '../../../legacy/dash-components/dash-redirect/DashRedirect'
import { useCurrentAccountContext } from '../../../utils/current-account/CurrentAccountContext'
import { RouteSuspense } from '../../../legacy/dash-components/route-suspense/RouteSuspense'
import { useCoreContext } from '../../../utils/core/RPPCoreContext'
import { useDatadogPrivacy } from '../../../gin-and-tonic/containers/datadog-privacy/DatadogPrivacy'

export const PublicRoutes: FunctionComponent<PropsWithChildren<unknown>> = () => {
  // Account data comes from CurrentAccountContext, provided by AppProviderPreloader.
  // AppProviderPreloader gates on loading, so by the time this component renders
  // account data is already resolved.
  const { authorized } = useCurrentAccountContext()
  const coreContext = useCoreContext()
  const publicRouters = useMemo(
    () => coreContext.publicRouters.map(el => cloneElement(el, { key: el.props.route })),
    [coreContext]
  )

  const publicLogInRouteMatch = useRouteMatch(
    coreContext.routesByName['app-public-authentication-log-in']
  )

  // Since public has auth stuff with passwords and other sensitive data, we mask user input by default
  useDatadogPrivacy('mask-user-input')

  // If already authorized, and they are heading to the log-in page, direct them to the redirect page
  if (authorized && publicLogInRouteMatch) {
    return <DashRedirect toRoute="app-halt-redirect" />
  }

  return (
    <RouteSuspense>
      <DashSwitch>
        <DashRoute route="public">
          <DashSwitch>
            {publicRouters}

            <AuthenticationDomainRedirect toRoute="app-public-authentication-log-in" />
          </DashSwitch>
        </DashRoute>
        <DashRedirect toRoute="public" />
      </DashSwitch>
    </RouteSuspense>
  )
}
